"use client";

import ContactUsForm from "@/components/contact-us";
import { useEffect, useState } from "react";

export function ContactUs({ title }: { title: string }) {
  const [show, setShow] = useState(false);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <div>
      <button
        type="button"
        className="transition-all duration-150 hover:text-primary"
        onClick={() => {
          setShow(true);
        }}
      >
        {title}
      </button>

      {isClient && <ContactUsForm onClose={() => setShow(false)} show={show} />}
    </div>
  );
}
